
import { Week } from "../interfaces/week.interface";
import { WorkoutClass } from "./workout.class";

export class WeekClass implements Week {
  id: number = null
  week_number: number = null
  level: string = ''
  part: string = ''
  name: string = ''
  description: string = ''
  done: boolean = false
  workouts: Array<WorkoutClass> = []
}
